import { gsap } from 'gsap'
import type { AnimationPresets } from './types'

export const animations: AnimationPresets = {
  fade: (element: HTMLElement) => {
    const leftContent = element.querySelector('.step-left')
    const rightContent = element.querySelector('.step-right')
    
    if (leftContent && rightContent) {
      // Split layout: animate left and right content separately
      const tl = gsap.timeline()
      
      // Reset positions
      gsap.set([leftContent, rightContent], { opacity: 0 })
      
      // Animate in sequence
      tl.to(leftContent, { 
        opacity: 1, 
        duration: 0.6, 
        ease: 'power2.out' 
      })
      .to(rightContent, { 
        opacity: 1, 
        duration: 0.6, 
        ease: 'power2.out' 
      }, '-=0.3')
      
      return tl
    } else {
      // Fullscreen layout
      gsap.set(element.children, { opacity: 0 })
      return gsap.to(element.children, {
        opacity: 1,
        duration: 0.8,
        ease: 'power2.out'
      })
    }
  },

  slide: (element: HTMLElement) => {
    const leftContent = element.querySelector('.step-left')
    const rightContent = element.querySelector('.step-right')
    
    if (leftContent && rightContent) {
      // Apple-style slide from opposite sides
      const tl = gsap.timeline()
      
      // Reset positions
      gsap.set(leftContent, { x: -60, opacity: 0 })
      gsap.set(rightContent, { x: 60, opacity: 0 })
      
      // Slide in from sides
      tl.to(leftContent, {
        x: 0,
        opacity: 1,
        duration: 0.8,
        ease: 'power2.out'
      })
      .to(rightContent, {
        x: 0,
        opacity: 1,
        duration: 0.8,
        ease: 'power2.out'
      }, '-=0.5')
      
      return tl
    } else {
      // Fullscreen slide up
      gsap.set(element.children, { y: 50, opacity: 0 })
      return gsap.to(element.children, {
        y: 0,
        opacity: 1,
        duration: 0.8,
        ease: 'power2.out'
      })
    }
  },

  scale: (element: HTMLElement) => {
    const leftContent = element.querySelector('.step-left')
    const rightContent = element.querySelector('.step-right')
    
    if (leftContent && rightContent) {
      // Scale animation for split layout
      const tl = gsap.timeline()
      
      // Reset positions
      gsap.set(leftContent, { scale: 0.9, opacity: 0 })
      gsap.set(rightContent, { scale: 0.9, opacity: 0 })
      
      // Scale up with slight stagger
      tl.to(leftContent, {
        scale: 1,
        opacity: 1,
        duration: 0.8,
        ease: 'back.out(1.2)'
      })
      .to(rightContent, {
        scale: 1,
        opacity: 1,
        duration: 0.8,
        ease: 'back.out(1.2)'
      }, '-=0.4')
      
      return tl
    } else {
      // Fullscreen scale
      gsap.set(element.children, { scale: 0.8, opacity: 0 })
      return gsap.to(element.children, {
        scale: 1,
        opacity: 1,
        duration: 0.8,
        ease: 'back.out(1.7)'
      })
    }
  }
}